module.exports = __webpack_public_path__ + "static/media/markazOffice.399011e4.jpg";